import React from "react";
import classes from "./StatusBar.module.css";
const StatusBar = ({ progress, goBack }) => {
  let percentage = progress * 8;
  return (
    <div className={classes.progressAndBack}>
      {goBack && (
        <button onClick={goBack} className={classes.backButton}>
          <span className={classes.backArrow}>&#x3c;</span>
          <span>Back</span>
        </button>
      )}
      <div className={classes.progressBar}>
        <div
          style={{ width: `${percentage}%` }}
          className={classes.progress}
        ></div>
      </div>
    </div>
  );
};

export default StatusBar;
